import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { GoogleMap, Marker } from "react-google-maps";
import { Select, notification } from 'antd';

const uri_brands = URI_SETUP+"catalog/brand";
const uri_hotels = URI_SETUP+"hotel";

const Option = Select.Option;
const MyMapComponent = (props) =>
  <GoogleMap
    defaultZoom={8}
    defaultCenter={{ lat: -34.397, lng: 150.644 }}
  >
    {props.isMarkerShown && <Marker position={{ lat: -34.397, lng: 150.644 }} />}
  </GoogleMap>


class BrandsHotels extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            brands                  : [],
            hotels                  : [],
            brand                   : {
                                        _id         : "",
                                        name        : ""
                                    },
            hotel                   : {
                                        _id         : "",
                                        name        : "",
                                        stars       : "",
                                        brand_id    : "",
                                        region_id   : "",
                                        status      : "",
                                        street      : "",
                                        number      : "",
                                        postal_code : "",
                                        district    : "",
                                        city        : "",
                                        state       : "",
                                        location    : ""
                                    },
            status_hotel_details                : "hide",
            status_brand_modal                  : "hide",
            status_brand_hotels                 : "hide",
            brand_action                        : "new",
            hotel_action                        : "new",
            background_filter                   : "",
            active_tab                          : "details",
            status_confirm_hotel_deletion       : "hide",
            status_alert_brand_deletion         : "hide",
            status_confirm_brand_deletion       : "hide",
            hotel_direct_competition            : [],
            target_marketing                    : []
            }
    }

    componentWillMount(){
        this.getBrands();

        let hotel_direct_competition = [];
        let target_marketing = [];
        {Object.keys(this.props.sys_tags.hotel_direct_competition.values).map((key, index) => {
            hotel_direct_competition.push(<Option key={key}>{this.props.sys_tags.hotel_direct_competition.values[key]}</Option>);
            })
        }
        {Object.keys(this.props.sys_tags.target_marketing.values).map((key, index) => {
            target_marketing.push(<Option key={key}>{this.props.sys_tags.target_marketing.values[key]}</Option>);
            })
        }

        this.setState({ 
            hotel_direct_competition,
            target_marketing
            })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.sys_tags != this.props.sys_tags) {
            let hotel_direct_competition = [];
            let target_marketing = [];
            {Object.keys(this.props.sys_tags.hotel_direct_competition.values).map((key, index) => {
                hotel_direct_competition.push(<Option key={key}>{index}</Option>);
                })
            }
            {Object.keys(this.props.sys_tags.target_marketing.values).map((key, index) => {
                target_marketing.push(<Option key={key}>{index}</Option>);
                })
            }

            this.setState({ 
                hotel_direct_competition,
                target_marketing
                })
        }
    }

    // ----------------------- Handlers -----------------------
    handleTargetMarket(value){
        console.log(`selected ${value}`);
    }

    handleDirectCompetition(value){
        console.log(`selected ${value}`);
    }
    
    handleActiveTab(active_tab){
        let self = this;
        self.setState({ 
            active_tab     : active_tab
            })
    }

    handleBrandSelector(brand) {
        let self = this;
        axios.get(uri_hotels, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                brand_id        : brand._id.$oid
            }
        }).then(request => { 
            self.setState({ 
            hotels                  : request.data,
            brand                   : brand,
            status_brand_hotels     : "",
            status_hotel_details    : "hide"
            }) 
        })
    }

    handleEditBrand() {
        let self = this;
        self.setState({ 
            status_brand_modal      : "",
            background_filter       : "blur",
            brand_action            : "edit"
            })
    }

    handleDeleteBrand() {
        let self = this;
        if(this.state.hotels.length>0){
            self.setState({ 
                status_alert_brand_deletion     : "",
                background_filter               : "blur"
                })
        }else{
            self.setState({ 
                status_confirm_brand_deletion     : "",
                background_filter                 : "blur"
                })
        }
    }

    handleNewBrand() {
        let self = this;
        self.clearBrand();
        self.setState({ 
            status_brand_modal      : "",
            background_filter       : "blur",
            status_brand_hotels     : "hide",
            status_hotel_details    : "hide",
            brand_action            : "new"
            })
    }

    handleBrandChange = (e) => {
        let brand = Object.assign({}, this.state.brand);
        brand[e.target.name] = e.target.value;
        this.setState({brand});
    }

    handleHotelSelector(hotel) {
        let self = this;
        self.setState({ 
            hotel                   : hotel,
            status_hotel_details    : "",
            hotel_action            : "edit"
            })
    }

    handleNewHotel() {
        let self = this;
        self.clearHotel();
        self.setState({ 
            status_hotel_details    : "",
            hotel_action            : "new"
            })
    }

    handleHotelChange = (e) => {
        let hotel = Object.assign({}, this.state.hotel);
        hotel[e.target.name] = e.target.value;
        this.setState({hotel});
    }

    handleSaveHotelKeyPress = (event) => {
        if(event.key == 'Enter'){
            event.preventDefault();
            this.onSubmitHotel();
        }
    }

    handleSaveBrandKeyPress = (event) => {
        if(event.key == 'Enter'){
            event.preventDefault();
            this.onSubmitBrand();
        }
    }

    // ----------------------- Functions -----------------------

    getBrands(){
        let self = this;
        axios.get(uri_brands, { 
            params: {
                api_token   : localStorage.getItem("api_token")
            }
        }).then(request => { 
            self.setState({ 
                brands                : request.data
            }) 
            
        })
    }

    clearBrand(){
        let self = this;
        self.setState({ 
            brand      : {
                _id         : "",
                name        : ""
            }
            })
    }

    refreshBrand(){
        let self = this;
        let brand_founded=[];
        
        Object.keys(self.state.brands).map((key, index) => {
            if (self.state.brands[key]._id.$oid==self.state.brand._id.$oid){
                brand_founded=self.state.brands[key];
            }
        })

        self.setState({ 
            brand      : brand_founded
            })
    }

    cancelBrand(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_brand_modal    : "hide",
            background_filter        : ""
            })
        if(self.state.brand_action!="new"){
            self.refreshBrand();
        }
        
    }

    onSubmitBrand(){
        let self = this;
        var qs = require("qs");

        const brandToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            name: self.state.brand.name
        });
        if(self.state.brand_action=="new"){
            axios.post(uri_brands, brandToSent)
                    .then(request => { 
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message,
                          });
                    })
        }else{
            axios.post(uri_brands+"/"+self.state.brand._id.$oid, brandToSent)
            .then(request => { 
                notification.open({
                    message: request.data.result.type,
                    description: request.data.result.message,
                  });
            })   

        }

        self.setState({ 
            status_brand_modal      : "hide",
            background_filter       : "",
            })
        
        self.getBrands();
    }

    clearHotel(){
        let self = this;
        self.setState({ 
            hotel                   : {
                _id         : "",
                name        : "",
                brand_id    : "",
                region_id   : "",
                status      : "",
                street      : "",
                number      : "",
                postal_code : "",
                district    : "",
                city        : "",
                state       : "",
                location    : "",
                stars       : ""    
            }
            })
    }

    refreshHotel(){
        let self = this;
        let hotel_founded=[];
        
        Object.keys(self.state.hotels).map((key,index) => {
            if (self.state.hotels[key]._id == self.state.hotel._id){
                hotel_founded=self.state.hotel[key];
            }
        })

        self.setState({ 
            hotel      : hotel_founded
            })
    }

    cancelHotel(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_hotel_details    : "hide"
            })
    }

    onSubmitHotel(){
        let self = this;
        var qs = require("qs");

        const hotelToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            brand_id    : self.state.brand._id.$oid,
            name        : self.state.hotel.name,
            status      : self.state.hotel.status,
            street      : self.state.hotel.street,
            number      : self.state.hotel.number,
            postal_code : self.state.hotel.postal_code,
            district    : self.state.hotel.district,
            city        : self.state.hotel.city,
            state       : self.state.hotel.state,
            location    : self.state.hotel.location,
            stars       : self.state.hotel.stars

        });
        if(self.state.hotel_action=="new"){
            axios.post(uri_hotels, hotelToSent)
                    .then(request => { 
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message,
                          });
                    })
        }else{
            axios.post(uri_hotels+"/"+self.state.hotel._id, hotelToSent)
            .then(request => { 
                notification.open({
                    message: request.data.result.type,
                    description: request.data.result.message,
                  });
            })   

        }

        self.props.getHotels();
        self.refreshHotel.bind(this);
        self.handleBrandSelector(self.state.brand);
        
    }

    openConfirmHotelDeletion(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_confirm_hotel_deletion    : "",
            background_filter       : "blur"
            })
    }

    confirmHotelDeletion(e) {
        let self = this;
        e.preventDefault();
        var qs = require("qs");

        const valuesToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            name: self.state.brand.name
        });

        axios.post(uri_hotels+"/"+self.state.hotel._id+"/destroy", valuesToSent)
            .then(request => {
                notification.open({
                    message: request.data.result.type,
                    description: request.data.result.message,
                  });
                self.handleBrandSelector(self.state.brand);
                self.setState({ 
                    status_confirm_hotel_deletion    : "hide",
                    background_filter                : ""
                }) 
        })
    }

    cancelConfirmHotelDeletion(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_confirm_hotel_deletion    : "hide",
            background_filter       : ""
            })
    }

    openConfirmBrandDeletion(){
        let self = this;
        self.setState({ 
            status_confirm_brand_deletion    : "",
            background_filter       : "blur"
            })
    }

    confirmBrandDeletion(e) {
        let self = this;
        e.preventDefault();
        var qs = require("qs");

        const valuesToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            name: self.state.brand.name
        });

        axios.post(uri_brands+"/"+this.state.brand._id.$oid+"/destroy", valuesToSent)
            .then(request => {
                notification.open({
                    message: request.data.result.type,
                    description: request.data.result.message,
                  });
                self.getBrands();
                self.setState({ 
                    status_confirm_brand_deletion   : "hide",
                    status_brand_hotels             : "hide",
                    background_filter               : ""
                }) 
        })
    }

    cancelConfirmBrandDeletion(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_confirm_brand_deletion    : "hide",
            background_filter       : ""
            })
    }

    confirmBrandAlert(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_alert_brand_deletion    : "hide",
            background_filter              : ""
            })
    }

    // ----------------------- Renders -----------------------

    renderBrands() {
        return <ul>
                    {Object.keys(this.state.brands).map((key, index) => {
                        if(this.state.brands[key]!=undefined){
                            return (<li key={this.state.brands[key]._id.$oid} onClick={this.handleBrandSelector.bind(this, this.state.brands[key])} >
                                        <div className={(this.state.brands[key]._id.$oid==this.state.brand._id.$oid)?"selected":""} >{this.state.brands[key].name}<i className="fa fa-plus-circle clickable"></i></div>
                                    </li>);
                            }
                        })
                    
                    }
                </ul>   
    }

    renderBrandModal() {
        return <div className="box regular col-md-4 ">
                    <h3>{this.state.brand_action=="new"? "NEW BRAND": "EDIT BRAND" } <i className="fa fa-times-circle" onClick={this.cancelBrand.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="brand_form" >
                            <input type="hidden" name="brand" value={(this.state.brand._id.$oid==null)? "": this.state.brand._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label htmlFor="name">{this.state.brand_action=="new"? "Add new brand": "Edit brand name" }</label>
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.brand.name==null)? "": this.state.brand.name} required onChange={e => this.handleBrandChange(e)} onKeyPress={this.handleSaveBrandKeyPress}  />          
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelBrand.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="button" className="blue" onClick={this.onSubmitBrand.bind(this)}>SAVE</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderConfirmHotelDeletion() {
        return <div className="box notifications col-md-4 ">
                    <h3>NOTIFICATION <i className="fa fa-times-circle" onClick={this.cancelConfirmHotelDeletion.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="form_hotel_deletion" >
                            <input type="hidden" name="brand" value={(this.state.brand._id.$oid==null)? "": this.state.brand._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <h4>Are you sure you want to continue?</h4>
                                    <p>By confirming this proccess you accept to remove all the dependences for this Hotel, any information related to it need to be reassigned</p>
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelConfirmHotelDeletion.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button onClick={this.confirmHotelDeletion.bind(this)} className="blue">CONFIRM</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    }

    renderAlertBrandDeletion() {
        return <div className="box notifications col-md-4 ">
                    <h3>NOTIFICATION <i className="fa fa-times-circle" onClick={this.confirmBrandAlert.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="brand_form" onSubmit={this.confirmBrandAlert.bind(this)}>
                            <input type="hidden" name="brand" value={(this.state.brand._id.$oid==null)? "": this.state.brand._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <h4>This action can't be completed</h4>
                                    <p>In order to remove this brand you should remove any hotel assigned to it</p>
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-12">
                                        <button type="submit" className="confirm">CLOSE</button>   
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderConfirmBrandDeletion() {
        return <div className="box notifications col-md-4 ">
                    <h3>NOTIFICATION <i className="fa fa-times-circle" onClick={this.cancelConfirmBrandDeletion.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="brand_form" onSubmit={this.confirmBrandDeletion.bind(this)}>
                            <input type="hidden" name="brand" value={(this.state.brand._id.$oid==null)? "": this.state.brand._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <h4>Are you sure you want to continue?</h4>
                                    <p>By confirming this proccess you accept to remove all the dependences for this Brand, any information related to it need to be reassigned</p>
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">  
                                        <button onClick={this.cancelConfirmBrandDeletion.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="confirm">CONFIRM</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderHotels() {
        return  <ul>
                    <li className="list-header"><div className="label">{this.state.brand.name} </div></li>
                    {Object.keys(this.state.hotels).map((key , index) => {
                        return (<li key={index} onClick={this.handleHotelSelector.bind(this, this.state.hotels[key])} >
                                    <div className={(this.state.hotels[key]._id==this.state.hotel._id)?"selected":""} >{this.state.hotels[key].name}<i className="fa fa-edit clickable"></i></div>
                                </li>);
                        })
                    }
                </ul>   
                
    }
    
    renderHotelDetails() {
        return  <form id="hotel_form">
                    <ul className="tabs">
                        <li onClick={this.handleActiveTab.bind(this,"details")} className={"clickable "+(this.state.active_tab=="details"?"active":"")}>
                            <div>Property</div>
                        </li>
                        <li onClick={this.handleActiveTab.bind(this,"location")} className={"clickable "+(this.state.active_tab=="location"?"active":"")}>
                            <div>Location</div>
                        </li>
                    </ul>
                    <div className="tabcontent">
                        <div className={"tab-panel " + (this.state.active_tab=="details"?"":"hide")} id="details" >
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.hotel.name==null)? "": this.state.hotel.name} required  onChange={e => this.handleHotelChange(e)} onKeyPress={this.handleSaveHotelKeyPress}  />          
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <select className="form-control" name="stars" value={(this.state.hotel.stars==null)? "": this.state.hotel.stars} onChange={e => this.handleHotelChange(e)}  >
                                        <option value="" disabled>Stars</option>
                                        <option value="1">1 Star</option>
                                        <option value="2">2 Stars</option>
                                        <option value="3">3 Stars</option>
                                        <option value="4">4 Stars</option>
                                        <option value="5">5 Stars</option>
                                    </select>    
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label className="text-left">Target Market</label>
                                    <Select
                                        mode="tags"
                                        onChange={this.handleTargetMarket}
                                        tokenSeparators={[',']}
                                    >
                                        {this.state.target_marketing}
                                    </Select>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label className="text-left">Direct Competition</label>
                                    <Select
                                        mode="tags"
                                        onChange={this.handleDirectCompetition}
                                        tokenSeparators={[',']}
                                    >
                                        {this.state.hotel_direct_competition}
                                    </Select>
                                </div>
                            </div>

                        </div>
                        <div className={"tab-panel " + (this.state.active_tab=="location"?"":"hide")} id="location">
                            <div className="form-row">
                                <div className="col col-md-8">
                                    <input type="text" className="form-control" name="street" placeholder="Street" value={(this.state.hotel.street==null)? "": this.state.hotel.street} onChange={e => this.handleHotelChange(e)} onKeyPress={this.handleSaveHotelKeyPress} />          
                                </div>
                                <div className="col col-md-4">
                                    <input type="text" className="form-control" name="number" placeholder="Number" value={(this.state.hotel.number==null)? "": this.state.hotel.number} onChange={e => this.handleHotelChange(e)} onKeyPress={this.handleSaveHotelKeyPress} />          
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-8">
                                    <input type="text" className="form-control" name="district" placeholder="District" value={(this.state.hotel.district==null)? "": this.state.hotel.district} onChange={e => this.handleHotelChange(e)} onKeyPress={this.handleSaveHotelKeyPress} />          
                                </div>
                                <div className="col col-md-4">
                                    <input type="text" className="form-control" name="postal_code" placeholder="Postal code" value={(this.state.hotel.postal_code==null)? "": this.state.hotel.postal_code} onChange={e => this.handleHotelChange(e)} onKeyPress={this.handleSaveHotelKeyPress} />          
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col col-md-8">
                                    <input type="text" className="form-control" name="city" placeholder="City" value={(this.state.hotel.city==null)? "": this.state.hotel.city} onChange={e => this.handleHotelChange(e)}  />          
                                </div>
                                <div className="col col-md-4">
                                <select className="form-control" name="state" value={(this.state.hotel.state==null)? "": this.state.hotel.state} onChange={e => this.handleHotelChange(e)}  >
                                    <option value="" disabled>State</option>
                                    <option value="DIF">Distrito Federal</option>
                                    <option value="AGS">Aguascalientes</option>
                                    <option value="BCN">Baja California</option>
                                    <option value="BCS">Baja California Sur</option>
                                    <option value="CAM">Campeche</option>
                                    <option value="CHP">Chiapas</option>
                                    <option value="CHI">Chihuahua</option>
                                    <option value="COA">Coahuila</option>
                                    <option value="COL">Colima</option>
                                    <option value="DUR">Durango</option>
                                    <option value="GTO">Guanajuato</option>
                                    <option value="GRO">Guerrero</option>
                                    <option value="HGO">Hidalgo</option>
                                    <option value="JAL">Jalisco</option>
                                    <option value="MEX">M&eacute;xico</option>
                                    <option value="MIC">Michoac&aacute;n</option>
                                    <option value="MOR">Morelos</option>
                                    <option value="NAY">Nayarit</option>
                                    <option value="NLE">Nuevo Le&oacute;n</option>
                                    <option value="OAX">Oaxaca</option>
                                    <option value="PUE">Puebla</option>
                                    <option value="QRO">Quer&eacute;taro</option>
                                    <option value="ROO">Quintana Roo</option>
                                    <option value="SLP">San Luis Potos&iacute;</option>
                                    <option value="SIN">Sinaloa</option>
                                    <option value="SON">Sonora</option>
                                    <option value="TAB">Tabasco</option>
                                    <option value="TAM">Tamaulipas</option>
                                    <option value="TLX">Tlaxcala</option>
                                    <option value="VER">Veracruz</option>
                                    <option value="YUC">Yucat&aacute;n</option>
                                    <option value="ZAC">Zacatecas</option>
                                </select>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col col-md12">
                                    
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="form-row bottom-buttons-group">
                        <div className="col col-md-6">
                            <button onClick={this.cancelHotel.bind(this)}>CANCEL</button>   
                        </div>
                        <div className="col col-md-6">
                            <button onClick={this.openConfirmHotelDeletion.bind(this)}>DELETE</button>
                        </div>
                        <div className="col col-md-12">
                            <button className="blue" type="button" onClick={this.onSubmitHotel.bind(this)}>SAVE</button> 
                        </div>
                    </div>
                </form>
    }

    render() {
        return (
            
            <section>
                <div className={this.state.background_filter}>
                    <div className="bg-gray"></div>
                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2"> 
                            <span className="i-directory icon100"> </span>
                        </div>
                        <div className="col-md-8 px-2">    
                            <h2>Step 1: Let’s get acquainted.</h2>
                            <div className="description">
                                <p>The first step establishes the structure of your brand(s).  Start creating your panels by adding your brands on the left. Then, add each hotel for each brand and the corresponding hotel information on the right. </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-3">
                            <h3>BRANDS</h3>
                            <div className="list-in-box">
                                {this.renderBrands()}
                                <button className="blue" onClick={this.handleNewBrand.bind(this)}>NEW +</button>
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_brand_hotels}>
                            <h3>HOTELS</h3>
                            <div className="list-in-box">
                                {this.renderHotels()}
                                
                            </div>
                            <div className="col-md-6 bottom-buttons">
                                <button onClick={this.handleEditBrand.bind(this)}>EDIT</button>
                            </div>
                            <div className="col-md-6 bottom-buttons">
                                <button onClick={this.handleDeleteBrand.bind(this)}>DELETE</button>
                            </div>
                            <div className="col-md-12 bottom-buttons">
                                <button className="blue" onClick={this.handleNewHotel.bind(this)}>NEW +</button>  
                            </div>
                        </div>
                        <div className={"box regular col-md-5 " + this.state.status_hotel_details}>
                            <h3>HOTEL INFORMATION</h3>
                            <div className="form-in-box">
                                {this.renderHotelDetails()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal " + this.state.status_brand_modal}> 
                    {this.renderBrandModal()}
                </div>

                <div className={"modal " + this.state.status_confirm_hotel_deletion}> 
                    {this.renderConfirmHotelDeletion()}
                </div>

                <div className={"modal " + this.state.status_alert_brand_deletion}> 
                    {this.renderAlertBrandDeletion()}
                </div>

                <div className={"modal " + this.state.status_confirm_brand_deletion}> 
                    {this.renderConfirmBrandDeletion()}
                </div>
                
            </section>
        )
    }

}

export default BrandsHotels


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/BrandsHotels.js